import React from "react";
import { Route, Switch } from "react-router-dom";
import GuardedRoute from "./GuardedRoute";
import MainWrapper from "./MainWrapper";
import Layout from "../Layout/index";

import Team from "../LimeProxyComponents/Team";
import TeamRoles from "../LimeProxyComponents/TeamRoles";

import CreditsPending from "../LimeProxyComponents/Credits/CreditsPending/index.js";
import Users from "../LimeProxyComponents/Users/AllUsers";
import ActiveUsers from "../LimeProxyComponents/Users/ActiveUsers";
import PendingUsers from "../LimeProxyComponents/Users/PendingUsers";
import PaidUsers from "../LimeProxyComponents/Users/PaidUsers";
import RecentSignups from "../LimeProxyComponents/Users/RecentSignups";
import CancellationRequests from "../LimeProxyComponents/Users/CancellationRequests";
import TrialExpired from "../LimeProxyComponents/Users/TrialExpired";
import CancelledUsers from "../LimeProxyComponents/Users/CancelledUsers";
import UserDetails from "../LimeProxyComponents/Users/UserDetails";
import AuditLog from "../LimeProxyComponents/Logs/AuditLog/index";

import Products from "../LimeProxyComponents/Products";
import Packages from "../LimeProxyComponents/Packages";
import Subscriptions from "../LimeProxyComponents/Subscriptions";

import ProxySubnets from "../LimeProxyComponents/Proxy/ProxySubnets";
import ProxyNodeSubnets from "../LimeProxyComponents/Proxy/ProxySubnets/ProxyNodeSubnets";
import ProxyLocations from "../LimeProxyComponents/Proxy/ProxyLocations";
import ProxyUseCases from "../LimeProxyComponents/Proxy/ProxyUseCases";
import ResidentialProxies from "../LimeProxyComponents/Proxy/ResidentialProxies";
import ProxyTags from "../LimeProxyComponents/Proxy/ProxyTags";
import ProxyWebsites from "../LimeProxyComponents/Proxy/ProxyWebsites";
import ProxyNodes from "../LimeProxyComponents/Proxy/ProxyNodes";

import Blocklist from "../LimeProxyComponents/Settings/Blocklist/index";
import OnVerify from "../LimeProxyComponents/Settings/OnVerify/index";

import RolePermissions from "../LimeProxyComponents/Roles/RolePermissions";

// import Transactions from "../LimeProxyComponents/Transactions/index";

// import ListOrders from "../LimeProxyComponents/ListOrders";

// import ManageOrders from "../LimeProxyComponents/ManageOrders";

import LimeProxyLogin from "../LimeProxyComponents/LimeProxyLogin/index";
import ForgetPassword from "../LimeProxyComponents/ForgetPassword/index";
import AcceptInvitation from "../LimeProxyComponents/AcceptInvitation/index";

// import Alerts from '../UI/Alerts/index';
// import Buttons from '../UI/Buttons/index';
// import Carousel from '../UI/Carousel/index';
// import Collapse from '../UI/Collapse/index';
// import Grids from '../UI/Grids';
// import Modals from '../UI/Modals/index';
// import Notifications from '../UI/Notification/index';
// import Panels from '../UI/Panels/index';
// import ProgressBars from '../UI/ProgressBars/index';
// import RangeSliders from '../UI/RangeSliders/index';
// import Tabs from '../UI/Tabs/index';
// import Timeline from '../UI/Timeline/index';
// import Tooltips from '../UI/Tooltips/index';
// import Typography from '../UI/Typography/index';
//
// import BasicTables from '../Tables/BasicTables/index';
// import DataTable from '../Tables/DataTable/index';
// import EditableTable from '../Tables/EditableTable/index';
// import MaterialTable from '../Tables/MaterialTable/index';
//
// import GoogleMap from '../Maps/GoogleMap/index';
// import VectorMap from '../Maps/VectorMap/index';

import NotFound404 from "../DefaultPage/404/index";
import Unauthorized401 from "../DefaultPage/401/index";

// import Calendar from '../DefaultPage/Calendar/index';
// import FAQ from '../DefaultPage/Faq/index';
// import Gallery from '../DefaultPage/Gallery/index';
// import Chat from '../Chat/index';
// import PricingCards from '../DefaultPage/PricingCards/index';
// import TextEditor from '../DefaultPage/TextEditor/index';
// import InvoiceTemplate from '../DefaultPage/InvoiceTemplate/index';
// import SearchResults from '../DefaultPage/SearchResults/index';
// import ProjectSummary from '../DefaultPage/ProjectSummary/index';
//
// import Catalog from '../ECommerce/Catalog/index';
// import ProductPage from '../ECommerce/product_page/index';
//
// import Profile from '../Account/Profile/index';
// import EmailConfirmation from '../Account/EmailConfimation/index';
import LockScreen from "../Account/LockScreen/index";
// import LogIn from '../Account/LogIn/index';
// import LogInPhoto from '../Account/log_in_photo/index';
// import Register from '../Account/Register/index';
import RegisterPhoto from "../Account/RegisterPhoto/index";

// import BasicForm from '../Form/BasicForm/index';
// import FormDropzone from '../Form/FormDropzone/index';
// import FileUpload from '../Form/FileUpload/index';
// import FormLayouts from '../Form/FormLayouts/index';
// import CheckFormControls from '../Form/CheckFormControls/index';
// import FormValidation from '../Form/FormValidation/index';
// import MaskForm from '../Form/MaskForm/index';
// import WizardForm from '../Form/WizardForm/index';
// import MaterialForm from '../Form/MaterialForm/index';
// import FloatingLabelsForm from '../Form/FloatingLabelsForm/index';
// import FormPicker from '../Form/FormPicker/index';

// import Cart from '../ECommerce/Cart/index';
// import OrdersList from '../ECommerce/OrdersList/index';
// import Payment from '../ECommerce/Payment/index';
// import ProductEdit from '../ECommerce/ProductEdit/index';
// import ProductsList from '../ECommerce/ProductsList/index';

// import ChartsJS from '../Charts/ChartJs/index';
// import ReactVis from '../Charts/ReactVis/index';
// import Recharts from '../Charts/Recharts/index';

// import FitnessDashboard from "../Dashboards/Fitness/index";
// import DefaultDashboard from '../Dashboards/Default/index';
import ECommerceDashboard from "../Dashboards/ECommerce/index";
// import CryptoDashboard from '../Dashboards/Crypto/index';
//
// import Mail from '../Mail/index';
//
import Introduction from "../Documentation/01_introduction/index";
import Installation from "../Documentation/02_installation/index";
import FileStructure from "../Documentation/03_files_structure/index";
import Components from "../Documentation/04_components/index";
import Form from "../Documentation/05_forms/index";
import ColorThemes from "../Documentation/06_change_and_add_color_themes/index";
import NavigationItem from "../Documentation/07_new_navigation_item/index";
import Resources from "../Documentation/08_resources/index";
import Changelog from "../Documentation/09_changelog/index";
//
//
// import CryptoDashboardEdit from '../Dashboards/CryptoTableEdit/index';
import ECommerceDashboardEdit from "../Dashboards/ECommerceTableEdit/index";

// const UI = () => (
//   <Switch>
//     <GuardedRoute path="/ui/alerts" component={Alerts} />
//     <GuardedRoute path="/ui/buttons" component={Buttons} />
//     <GuardedRoute path="/ui/carousel" component={Carousel} />
//     <GuardedRoute path="/ui/collapse" component={Collapse} />
//     <GuardedRoute path="/ui/grids" component={Grids} />
//     <GuardedRoute path="/ui/modals" component={Modals} />
//     <GuardedRoute path="/ui/notifications" component={Notifications} />
//     <GuardedRoute path="/ui/panels" component={Panels} />
//     <GuardedRoute path="/ui/progress_bars" component={ProgressBars} />
//     <GuardedRoute path="/ui/range_sliders" component={RangeSliders} />
//     <GuardedRoute path="/ui/tabs" component={Tabs} />
//     <GuardedRoute path="/ui/timeline" component={Timeline} />
//     <GuardedRoute path="/ui/tooltips" component={Tooltips} />
//     <GuardedRoute path="/ui/typography" component={Typography} />
//   </Switch>
// );
//
// const Forms = () => (
//   <Switch>
//     <GuardedRoute path="/forms/basic_form" component={BasicForm} />
//     <GuardedRoute path="/forms/check_form_controls" component={CheckFormControls} />
//     <GuardedRoute path="/forms/file_upload" component={FileUpload} />
//     <GuardedRoute path="/forms/floating_labels_form" component={FloatingLabelsForm} />
//     <GuardedRoute path="/forms/form_dropzone" component={FormDropzone} />
//     <GuardedRoute path="/forms/form_layouts" component={FormLayouts} />
//     <GuardedRoute path="/forms/form_picker" component={FormPicker} />
//     <GuardedRoute path="/forms/form_validation" component={FormValidation} />
//     <GuardedRoute path="/forms/mask_form" component={MaskForm} />
//     <GuardedRoute path="/forms/material_form" component={MaterialForm} />
//     <GuardedRoute path="/forms/wizard_form" component={WizardForm} />
//   </Switch>
// );
//
// const Tables = () => (
//   <Switch>
//     <GuardedRoute path="/tables/basic_tables" component={BasicTables} />
//     <GuardedRoute path="/tables/data_table" component={DataTable} />
//     <GuardedRoute path="/tables/editable_table" component={EditableTable} />
//     <GuardedRoute path="/tables/material_table" component={MaterialTable} />
//   </Switch>
// );
//
// const Charts = () => (
//   <Switch>
//     <GuardedRoute path="/charts/charts_js" component={ChartsJS} />
//     <GuardedRoute path="/charts/react_vis" component={ReactVis} />
//     <GuardedRoute path="/charts/recharts" component={Recharts} />
//   </Switch>
// );
//
// const Maps = () => (
//   <Switch>
//     <GuardedRoute path="/maps/google_map" component={GoogleMap} />
//     <GuardedRoute path="/maps/vector_map" component={VectorMap} />
//   </Switch>
// );
//
// const Account = () => (
//   <Switch>
//     <GuardedRoute path="/account/profile" component={Profile} />
//     <GuardedRoute path="/account/email_confirmation" component={EmailConfirmation} />
//   </Switch>
// );
//
// const ECommerce = () => (
//   <Switch>
//     <GuardedRoute path="/e-commerce/cart" component={Cart} />
//     <GuardedRoute path="/e-commerce/catalog" component={Catalog} />
//     <GuardedRoute path="/e-commerce/orders_list" component={OrdersList} />
//     <GuardedRoute path="/e-commerce/payment" component={Payment} />
//     <GuardedRoute path="/e-commerce/product_edit" component={ProductEdit} />
//     <GuardedRoute path="/e-commerce/product_page" component={ProductPage} />
//     <GuardedRoute path="/e-commerce/products_list" component={ProductsList} />
//   </Switch>
// );

// const DefaultPages = () => (
//   <Switch>
//     <GuardedRoute path="/default_pages/calendar" component={Calendar} />
//     <GuardedRoute path="/default_pages/faq" component={FAQ} />
//     <GuardedRoute path="/default_pages/gallery" component={Gallery} />
//     <GuardedRoute path="/default_pages/invoice_template" component={InvoiceTemplate} />
//     <GuardedRoute path="/default_pages/pricing_cards" component={PricingCards} />
//     <GuardedRoute path="/default_pages/project_summary" component={ProjectSummary} />
//     <GuardedRoute path="/default_pages/search_results" component={SearchResults} />
//     <GuardedRoute path="/default_pages/text_editor" component={TextEditor} />
//   </Switch>
// );

const Documentation = () => (
  <Switch>
    <GuardedRoute path="/documentation/introduction" component={Introduction} />
    <GuardedRoute path="/documentation/installation" component={Installation} />
    <GuardedRoute
      path="/documentation/file_structure"
      component={FileStructure}
    />
    <GuardedRoute path="/documentation/components" component={Components} />
    <GuardedRoute path="/documentation/form" component={Form} />
    <GuardedRoute path="/documentation/color_themes" component={ColorThemes} />
    <GuardedRoute
      path="/documentation/navigation_item"
      component={NavigationItem}
    />
    <GuardedRoute path="/documentation/resources" component={Resources} />
    <GuardedRoute path="/documentation/changelog" component={Changelog} />
  </Switch>
);

// const Crypto = () => (
//   <Switch>
//     <GuardedRoute exact path="/dashboard_crypto" component={CryptoDashboard} />
//     <GuardedRoute path="/dashboard_crypto/edit/:index" component={CryptoDashboardEdit} />
//   </Switch>
// );

const Commerce = () => (
  <Switch>
    <GuardedRoute exact path="/dashboard" component={ECommerceDashboard} />
    <GuardedRoute
      path="/dashboard_default/edit/:index"
      component={ECommerceDashboardEdit}
    />
  </Switch>
);

const CreditsRoutes = () => (
  <Switch>
    <GuardedRoute exact path="/credits/pending" component={CreditsPending} />
  </Switch>
);

const UsersRoutes = () => (
  <Switch>
    <GuardedRoute exact path="/users/active" component={ActiveUsers} />
    <GuardedRoute exact path="/users/recent" component={RecentSignups} />
    <GuardedRoute exact path="/users/cancelled" component={CancelledUsers} />
    <GuardedRoute exact path="/users/all" component={Users} />
    <GuardedRoute
      exact
      path="/users/cancellation_requests"
      component={CancellationRequests}
    />
    <GuardedRoute exact path="/users/trial_expired" component={TrialExpired} />
    <GuardedRoute exact path="/users/pending" component={PendingUsers} />
    <GuardedRoute exact path="/users/paid" component={PaidUsers} />
    <GuardedRoute exact path="/users/details/:id" component={UserDetails} />
  </Switch>
);

const SubscriptionsRoutes = () => (
  <Switch>
    <GuardedRoute
      exact
      path="/subscriptions/:status"
      component={Subscriptions}
    />
  </Switch>
);

const ProductRoutes = () => (
  <Switch>
    <GuardedRoute exact path="/products/" component={Products} />
  </Switch>
);

const PackagesRoutes = () => (
  <Switch>
    <GuardedRoute exact path="/packages/" component={Packages} />
  </Switch>
);

const LogsRoutes = () => (
  <Switch>
    <GuardedRoute exact path="/logs/audit/" component={AuditLog} />
  </Switch>
);

const SettingsRoutes = () => (
  <Switch>
    <GuardedRoute exact path="/settings/blocklist" component={Blocklist} />
    <GuardedRoute exact path="/settings/on-verify" component={OnVerify} />
  </Switch>
);

const ProxyRoutes = () => (
  <Switch>
    <GuardedRoute exact path="/proxy/subnets" component={ProxySubnets} />
    <GuardedRoute
      exact
      path="/proxy/subnets/users/:subnetId"
      component={Users}
    />
    <GuardedRoute
      exact
      path="/proxy/node-subnets/:lid"
      component={ProxyNodeSubnets}
    />
    <GuardedRoute exact path="/proxy/locations" component={ProxyLocations} />
    <GuardedRoute
      exact
      path="/proxy/locations/users/:locationId"
      component={Users}
    />
    <GuardedRoute
      exact
      path="/proxy/products/users/:productId"
      component={Users}
    />
    <GuardedRoute exact path="/proxy/use-cases" component={ProxyUseCases} />
    <GuardedRoute
      exact
      path="/proxy/residential-proxies"
      component={ResidentialProxies}
    />
    <GuardedRoute
      exactf
      path="/proxy/use-cases/users/:useCaseId"
      component={Users}
    />
    <GuardedRoute exact path="/proxy/websites" component={ProxyWebsites} />
    <GuardedRoute
      exact
      path="/proxy/websites/users/:website"
      component={Users}
    />
    <GuardedRoute exact path="/proxy/nodes" component={ProxyNodes} />

    <GuardedRoute exact path="/proxy/tags" component={ProxyTags} />
    <GuardedRoute exact path="/proxy/tags/users/:tagId" component={Users} />
  </Switch>
);

// const TransactionRoutes = () => (
//   <Switch>
//     <GuardedRoute exact path="/transactions/all" component={Transactions} />
//   </Switch>
// );

// <GuardedRoute path="/dashboard_crypto" component={Crypto} />
// <GuardedRoute path="/ui" component={UI} />
// <GuardedRoute path="/mail" component={Mail} />
// <GuardedRoute path="/chat" component={Chat} />
// <GuardedRoute path="/forms" component={Forms} />
// <GuardedRoute path="/tables" component={Tables} />
// <GuardedRoute path="/charts" component={Charts} />
// <GuardedRoute path="/maps" component={Maps} />
// <GuardedRoute path="/account" component={Account} />
// <GuardedRoute path="/e-commerce" component={ECommerce} />
// <GuardedRoute path="/default_pages" component={DefaultPages} />
// <GuardedRoute path="/documentation" component={Documentation} />
// <GuardedRoute path="/dashboard_default" component={DefaultDashboard} />

// const RolesRoutes = () => (
//   <Switch>
//     <GuardedRoute exact path="/roles" component={Roles} />
//     <GuardedRoute exact path="/roles/edit/:id" component={RolesEdit} />
//   </Switch>
// );

const wrappedRoutes = () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <GuardedRoute path="/dashboard" component={Commerce} />
      {/* <GuardedRoute path="/panel_protection" component={FitnessDashboard} /> */}
      <GuardedRoute path="/documentation" component={Documentation} />
      <GuardedRoute path="/team" component={Team} />
      <GuardedRoute path="/roles" component={TeamRoles} />
      <GuardedRoute path="/permissions/:rid" component={RolePermissions} />
      <GuardedRoute path="/users" component={UsersRoutes} />
      <GuardedRoute path="/products" component={ProductRoutes} />
      <GuardedRoute path="/credits" component={CreditsRoutes} />
      <GuardedRoute path="/packages" component={PackagesRoutes} />
      <GuardedRoute path="/subscriptions" component={SubscriptionsRoutes} />
      <GuardedRoute path="/logs" component={LogsRoutes} />
      <GuardedRoute path="/proxy" component={ProxyRoutes} />
      <GuardedRoute path="/settings" component={SettingsRoutes} />
      {/* <GuardedRoute path="/transactions" component={TransactionRoutes} />
      <GuardedRoute path="/list_orders" component={ListOrders} />
      <GuardedRoute path="/manage_orders" component={ManageOrders} /> */}
    </div>
  </div>
);

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/" component={LimeProxyLogin} />
        <Route exact path="/forgot-password" component={ForgetPassword} />
        <Route
          exact
          path="/admin/validate/:token"
          component={AcceptInvitation}
        />
        <Route exact path="/login" component={LimeProxyLogin} />
        <Route path="/404" component={NotFound404} />
        <Route path="/401" component={Unauthorized401} />
        <Route path="/lock_screen" component={LockScreen} />
        <Route path="/register" component={RegisterPhoto} />
        <Route path="/" component={wrappedRoutes} />
        <Route path="*" component={NotFound404} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
